import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/places`;

export const searchPlaces = async (searchRequest) => {
  const response = await axios.get(`${API_BASE_URL}/search`, {
    params: searchRequest
  });
  return response.data;
};
